<template>
  <CMS>
    <Loader v-if="!homeResource" />
    <Layout v-else :locale="locale" :locales="locales" :country="country" :countries="countries">
      <Blocks :resource="homeResource" />
    </Layout>
  </CMS>
</template>

<script>
import { Resource, LanguageFolder, CountryFolder } from 'beisheim/models'
import CMS from '@i22/frontend-cms-utils/components/cms'
import Loader from '@i22/frontend-cms-utils/components/loader'
import pageMixin from '@i22/frontend-cms-utils/mixins/page-mixin'
import externalScripts from 'beisheim/mixins/external-scripts'
import Blocks from 'beisheim/components/blocks'
import Layout from '@/components/layout'

export default {
  components: {
    Blocks,
    CMS,
    Layout,
    Loader
  },
  mixins: [ pageMixin, externalScripts ],
  beforeRouteLeave (to, from, next) {
    this.$store.commit('ui/closeOffscreen')
    next()
  },
  beforeRouteUpdate (to, from, next) {
    this.$store.commit('ui/closeOffscreen')
    next()
  },
  computed: {
    homeResource () {
      const isHome = this.$route.path === `/${this.$route.params.country}/${this.$route.params.language}`
      if (isHome) {
        return Resource.query().where('resource_class_name', 'HomePage').first()
      }
      return this.resource
    },
    locales () {
      return LanguageFolder.all()
    },
    locale () {
      return LanguageFolder.query().where(r =>
        r.columns.language === this.$route.params.language &&
        r.columns.country === this.$route.params.country
      ).first()
    },
    countries () {
      return CountryFolder.all()
    },
    country () {
      return CountryFolder.query().where(r =>
        r.columns.country === this.$route.params.country
      ).first()
    }
  },
  watch: {

  },
  mounted () {
    if (!this.$cms && !this.locale) {
      return this.$router.push('/')
    }
  },
  head () {
    return this.getExternalScripts();
  }
}
</script>
